import { Navigator } from "../../main_components/navigator.js";
import Styles from "./gemini.module.css";
import { GeminiContainer } from "./gemini_components.js";
export const GeminiBody = ( props ) => {
    const {  } = props;
    const { Body, Content } = Styles;
    document.body.scroll({
        top: document.body.scrollHeight,
    });
    return (
        <main className={ Body }>
            <Navigator page={ "Gemini" }/>
            <main className={ Content }>
                <GeminiContainer />
            </main>
        </main>
    );
};